import { Emitter, Event } from "../../../base/common/events";
import { IDisposable } from "../../../base/common/lifecycle";
import { URI } from "../../../base/common/uri";
import { createDecorator } from "../../instantiation/common/registry";

export const IResourceService = createDecorator<IResourceService>('resourceService');


export interface IResourceService {
    readonly _serviceBrand: undefined;

    readonly onDidChange: Event<ResourceChangedArguments>;

    /**
     * Registers a resource.
     */
    registerResource(resource: IResourceData): void;

    /**
     * Iterates over all registered resources.
     */
    iterateResources(): Iterable<IResourceData>;

    /**
     * Registers a metadata provider for a given scheme.
     */
    registerProvider(scheme: string, provider: IResourceViewProvider): IDisposable;

    /**
     * Gets the resource view for a given resource and scheme.
     */
    getResourceView<T extends IResourceData>(scheme:string, resource: T): IResourceView | null;
}

export interface ResourceChangedArguments {
    resourceAdded?: boolean;
    resourceDisposed?: boolean;
}
export interface IResourceData {
    readonly reference: object,
}


export interface ResourceViewChangeEvent {
    readonly resourceDisposed?: boolean;
}
/**
 * A view representation of a resource. Used to show resources in the UI.
 */
export interface IResourceView extends IDisposable {
    readonly onDidChange?: Event<ResourceViewChangeEvent>;

    name?: string;
    description?: string;
    tooltip?: string;
    uri?: URI;
}

export interface IResourceViewProvider {
    getResourceView(resource: IResourceData): IResourceView | null;
}




// #region Resource View Implementation

export abstract class ResourceView implements IResourceView {

    private readonly _onDidChange = new Emitter<ResourceViewChangeEvent>();
    readonly onDidChange = this._onDidChange.event;

    dispose(): void {
        this._onDidChange.dispose();
    }
}